import React from "react";
import { gql, useQuery } from "urql";
import {
  FaGithub,
  FaReddit,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaMedium,
  FaDiscord,
  FaYoutube,
} from "react-icons/fa";

import { SiMedium } from "react-icons/si";

import github from "../assets/fa/github.svg";
import facebook from "../assets/fa/facebook.svg";
import youtube from "../assets/fa/youtube.svg";
import discord from "../assets/fa/discord.svg";
import instagram from "../assets/fa/instagram-c.svg";
import linkedin from "../assets/fa/linkedin-c.svg";
import twitter from "../assets/fa/twitter-c.svg";
import medium from "../assets/fa/medium.svg";

import "./share-on-social.scss";

const ALL_SOCIAL_QUERY = gql`
  query allSocial {
    allSocial(sort: { priority: ASC }) {
      name
      url
      enabled
      icon {
        asset {
          url
        }
      }
    }
  }
`;

interface Props {
  url: string;
  text: string;
}

export const ShareOnSocial = (props: Props) => {
  const { url, text } = props;
  const [result] = useQuery({ query: ALL_SOCIAL_QUERY });
  const { data, fetching, error } = result;

  const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    `${text} by @hyperbrew 🚀\n\n${url}`
  )}`;
  const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?mini=true&url=${encodeURIComponent(
    url
  )}`;

  return (
    <div className="share-on-social--core">
      <label>Share on:</label>
      {data &&
        data.allSocial
          .filter((i) => i.enabled)
          .filter((i) => ["Twitter", "LinkedIn"].includes(i.name))
          .map((social: any, i: number) => (
            <a
              rel="noopener"
              key={i}
              title={social.name}
              //   href={social.url}
              href={
                (social.name === "Twitter" && twitterLink) ||
                (social.name === "LinkedIn" && linkedInLink)
              }
              target="_blank"
              className="social-item"
            >
              {(social.name === "LinkedIn" && (
                <img alt="LinkedIn" src={linkedin} />
              )) ||
                // (social.name === "Instagram" && (
                //   <img alt="Instagram" src={instagram} />
                // )) ||
                // (social.name === "Reddit" && (
                //   <img alt="Reddit" src={github} />
                // )) ||
                (social.name === "Twitter" && (
                  <img alt="Twitter" src={twitter} />
                ))}
            </a>
          ))}
    </div>
  );
};
